import { Modal } from 'bootstrap';
import { createModalElement } from '../utils/dom-creators.js';

const showConfirmDialog = (
    message,
    staticBackdrop = true,
    templateId = 'base-modal-template',
) => {
    return new Promise(resolve => {
        const modalElement = createModalElement({
            templateId: templateId,
            title: '確認',
            body: message,
            staticBackdrop: staticBackdrop,
            centered: true,
        });

        if (!modalElement) {
            resolve(false);
            return;
        }

        document.body.appendChild(modalElement);
        const bootstrapModal = new Modal(modalElement);

        const handleResult = (event) => {
            modalElement.querySelectorAll('[data-result]').forEach(button => button.removeEventListener('click', handleResult));
            const result = event.target.dataset.result === 'true';
            resolve(result);
            bootstrapModal.hide();
        };

        modalElement.querySelectorAll('[data-result]').forEach(button => button.addEventListener('click', handleResult));

        modalElement.addEventListener('hidden.bs.modal', () => {
            modalElement.remove();
        }, { once: true });

        modalElement.addEventListener('shown.bs.modal', () => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
            const okButton = modalElement.querySelector('[data-result="true"]');
            if (okButton instanceof HTMLElement) {
                okButton.focus();
            }
        }, { once: true });

        bootstrapModal.show();
    });
};

export const promiseConfirm = (message, modal, templateId) => showConfirmDialog(message, modal, templateId);
